import React, { useEffect } from 'react';
import Details from '../components/Details/Details'
import Index from '../components/Home/Home'


export default function Home() {
  const {search} = window.location;
  const pageFlag = search.includes('atlid');
  // console.log(window.location);
  return (
    <div>
      { pageFlag ? <Details /> : <Index />}
    </div>
  )
}
